import { TeachAppAndLandingColorPalette } from '@lalalilo/enums'

export { TeachAppAndLandingColorPalette as Color }

// Do not add more custom colors here
export enum CustomColor {
  grey = 'rgba(159, 169, 182, 1)',
  darkRed = 'rgba(206, 39, 7, 1)',
  canopeGreen = 'rgba(43, 103, 118, 1)',
}
